import { PropTypes } from 'prop-types';
import moment from 'moment';
import React from 'react';
import { Empty, Skeleton } from 'antd';
import { FixedSizeList as List } from 'react-window';
import isWebView from '$src/utils/user-agent';
import eventsToIconsMap, { guardReviewed } from '$src/pages/EventSummary/EventsToIconsMap';
import { activityHistory } from '$src/utils/RapidSolutionsIntegrations/urls';
import { navigateToRingApp } from '$src/utils/navigateToRingApp';

import './index.less';
import EventFilter from '../EventFilter';

function TabContentsEventList({ data, onFilterEventChange, loading, icon, total, onlyEmergencies, onScroll }) {
  const listItemSize = 120;
  const listHeight = listItemSize * total - 500;
  const listContainerHeight = 300;

  const onScrollList = ({ scrollOffset }) => {
    if (onScroll) {
      onScroll(scrollOffset > listHeight);
    }
  };

  const getEventListItem = ({ index, style }) => {
    if (index >= 0 && index < data.length) {
      const event = data[index];
      const eventData = eventsToIconsMap[event.resolution_type] ? eventsToIconsMap[event.resolution_type] : guardReviewed;
      const Icon = eventData.icon;
      const { isEmergency } = eventData;
      const eventDate = moment(event.timestamp);
      const eventLink = activityHistory(event.location_id, eventDate.unix(), isWebView());

      const handleLinkClick = (e, link) => {
        e.preventDefault();

        if (isWebView()) {
          navigateToRingApp(eventLink);
        } else {
          window.open(link, '_blank', 'noopener,noreferrer');
        }
      };

      return (
        <div style={style} className="list-events-card__list__item">
          <Icon className={isEmergency ? 'emergency' : ''} />
          <div className="list-events-card__list__item__details">
            <span> {event.locationName}</span>
            <span className="bold"> {eventData.displayName}</span>
            <a href={eventLink} onClick={(e) => handleLinkClick(e, eventLink)}>
              Event link
            </a>
          </div>
          <div className="list-events-card__list__item__date">
            <span>{eventDate.format('ddd, MMM DD')}</span>
            <span>{eventDate.format('h:mm A')}</span>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <>
      <EventFilter total={total} icon={icon} onChange={onFilterEventChange} onlyEmergencies={onlyEmergencies} />
      <Skeleton active loading={loading}>
        {data?.length > 0 ? (
          <List onScroll={onScrollList} className="list-events-card__list" height={listContainerHeight} itemCount={data.length} itemSize={listItemSize} width="100%">
            {getEventListItem}
          </List>
        ) : (
          <Empty data-testid="list-events-empty" image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}
      </Skeleton>
    </>
  );
}

TabContentsEventList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
  onFilterEventChange: PropTypes.func,
  loading: PropTypes.bool,
  icon: PropTypes.func,
  total: PropTypes.number,
  onlyEmergencies: PropTypes.bool,
  onScroll: PropTypes.func,
};

export default TabContentsEventList;
